// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:767px){.addToListMainWrapper[data-v-5d8cf04b]{height:100%}}", ""]);
// Exports
module.exports = exports;
